export const $PaintFamiliesModuleName = "paintFamilies";

export type TPaintFamiliesState = { families?: Array<string> | null };
